import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { OrgModule } from '../../../../modules/organization';
import { editSettingsModel } from '../../../../modules/organization/edit-settings.model';
import indiaStates from '../../../../../assets/js/india.state.list.json';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { FileUploadService } from 'src/app/Services/file-upload.service';

export interface User {
  name: string;
}
const urlPattern = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

@Component({
  selector: 'edit-org-info',
  templateUrl: './editorganization.component.html',
  styles: [`

::ng-deep .editOrgTabs .mat-tab-list .mat-tab-labels .mat-tab-label-active {
    color:rgb(255, 255, 255) !important;
    background-color: #4950b8 !important;
    height: 30px !important;
    width: 30px;
    font-size: 18px !important;
    }
    ::ng-deep .editOrgTabs .mat-tab-list .mat-tab-labels .mat-tab-label {
        height: 40px !important;
         border-right-style: ridge;
        font-size: 18px !important;
        border-image: linear-gradient( to bottom,#ff000000, #9196d5, rgb(29 29 29 / 0%) ) 1 10%;
        /* border-right-color: rgb(160, 160, 160); */
        width: 187px !important;
        }
    .custom-theme .editOrgTabs. mat-tab-group.mat-accent .mat-ink-bar, .custom-theme .editOrgTabs .mat-tab-nav-bar.mat-accent .mat-ink-bar {
      background-color: #d82929;
  }
  ::ng-deep .editOrgTabs.mat-tab-group{
      background-color: white;
  }
   ::ng-deep .editOrgTabs .mat-tab-label, ::ng-deep .editOrgTabs .mat-tab-label-active{
    min-width: 0!important;
    /* min-height: 10px !important; */
    padding: 3px!important;
    margin: 3px!important;
   }

   .editOrgTabs .mat-tab-label {

    height: 24px !important;

   }
   .form-control {
    height: calc(1.5em + .75rem + 7px);
    }

    .fileStyle {
        box-shadow: 0 1px 16px 0 rgb(0 0 0 / 20%), 0 2px 8px 0 rgb(0 0 0 / 14%), 0 4px 8px -1px rgb(0 0 0 / 12)
    }

    .fs-12{
        font-size: 12px;
    }

    .fileError{
        margin-top: 0.75rem;
        padding-left: 0.5rem;
    }

    .fileBtn{
        width: 30px;
        height: 30px; 
        line-height: 30px;
    }

    .fileCancelIcon{
        font-size:14px;
        height: 30px; 
        line-height: 26px; 
        color: red;
    }
    
     #sidebar {
      min-width: 250px;
      max-width: 250px;
    }
     
     .navFields{
      height: 40px;
      display: flex;
      align-items: center;
      background: white;
      border: 1px solid white;
      color:rgb(98,100,167);
      border-radius: 5px;
      padding-left: 10px;
      cursor:pointer;
     }
     .navFields:hover{
       border: 1px solid rgb(98,100,167);
     }
     .activeSidebar{
      height: 40px;
      display: flex;
      align-items: center;
      background: rgb(98,100,167);
      border: 1px solid rgb(98,100,167);
      color:white;
      border-radius: 5px;
      padding-left: 10px;
      cursor:pointer;
     }

     ::ng-deep #accordionExample1 .mat-form-field-appearance-outline .mat-form-field-wrapper {
     padding-bottom: 0 !important;
     margin: 0 !important;
     }

    ::ng-deep #accordionExample1 .mat-form-field {
    display: inline-block;
    position: relative;
    text-align: left;
    padding: 0px !important;
    }

    #accordionExample1 .setting-field{
    padding: 0.3rem 0.5rem 0rem 0.5rem !important;
    }
  `]
})
/*
 <div align="center">
      <span class="btn btn-sm btn-dark" (click)="modalClose()" *ngIf="__close">{{__close}}</span>
    </div>
 */
export class EditOrgComponent {
  orgID: string;
  OrgData: any;
  enableForm: boolean;
  organation: any = OrgModule;
  settings: any = editSettingsModel;
  isUserShow: boolean;
  isServiceShow: boolean;
  isAlertShow: boolean;
  settingsInfo = {};
  selectedIndex = 0;
  editSettingsForm: FormGroup;
  submittedform = false;
  settingsList: any;

  /* Form variables */
  public editOrganizationForm: FormGroup;
  public stateSelect = indiaStates.IND;
  public options: User[] = [];
  public profileImage: any;
  matFormSize = '13px';
  public updateValues = [];
  public formSubmitted: boolean = false;
  public settingsFormSubmit: boolean = false;

  public activeMenu: string = 'Field Map';
  public headers: any = [];
  public userRestrictionData: any = {}
  public tableData: any = {};
  public response: any;

  public dropdownOptions = 'single';

  public generalSettingsList: any = [
    {
      setting: 'Multi trip start', value: 'multiTripStart', checked: false
    },
    {
      setting: 'Employee app polyline', value: 'empAppPolyline', checked: false
    },
    {
      setting: 'Click to call', value: 'clicktocall', checked: false
    }, {
      setting: 'Breakdown', value: 'breakDown', checked: false
    }, {
      setting: 'Event', value: 'event', checked: false
    }, {
      setting: 'Self Attendance by Employee', value: 'selfAttendanceForEmp', checked: false
    }, {
      setting: 'Harsh Acceleration Braking', value: 'harshAccBraking', checked: false
    },
    {
      setting: 'Document Expiry Alert', value: 'documentExpiryAlert', checked: false
    }
  ]
  public general = {
    multiTripStart: false,
    empAttendance: 'single',
    empAppPolyline: false,
    driverTokenExp: 1,
    clicktocall: false,
    breakDown: false,
    event: false,
    selfAttendanceForEmp: false,
    driverTrackingInterval: 10,
    harshAccBraking: false,
    harshAccThreshold: 1.8,
    harshBrakingThreshold: 1.8,
    subscriptionExpiryDate: '' as any
  }
  disableTrue: boolean = false;
  disableTrue2: boolean = false;
  disableTrue3: boolean = false;
  disableTrue4: boolean = false;
  changed: boolean = false;
  errorContent: string;
  brakingDisable: boolean = false;
  errorContentHarshAcc: string;
  errorContentHarshBreak: string;
  public updateFiles: {}
  constructor(
    public api: ApiService,
    public router: Router,
    public swal: SweetAlert,
    public route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public file: FileUploadService,

  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.orgID = params.params.orgID;
    });
  }
  ngOnInit() {
    this.getOrgList();

    const states = {};
    const stateList = this.getStateOptions();
    for (const item of this.organation) {
      if (item.name == 'state') {
        item.options = stateList;
      }
    }

    this.settingFormLoad();
    this.getStateOptions();
    this.addFormLoad();
    this.findActiveMenu(this.activeMenu);
  }

  // -------------------------------
  getStateOptions() {
    this.stateSelect.forEach(element => { this.options.push({ name: element }) });
  }

  /* add form load */

  addFormLoad() {
    this.editOrganizationForm = new FormGroup({
      orgName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&,0-9 ]*$')]),   //Validators.minLength(5)
      orgEmail: new FormControl('', [Validators.required, Validators.email]),
      website: new FormControl('', [Validators.required, Validators.pattern(urlPattern)]),
      country: new FormControl('India', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-& ]*$')]),
      address: new FormControl('', [Validators.required]),
      pincode: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{5}')]),
      primaryContactName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      primaryContactEmail: new FormControl('', [Validators.required, Validators.email]),
      primaryContactNumber: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      primaryContactRole: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      secondaryContactName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      secondaryContactEmail: new FormControl('', [Validators.required, Validators.email]),
      secondaryContactNumber: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      secondaryContactRole: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z-_&, ]*$')]),   //Validators.minLength(5)
      map: new FormControl('osrm',),
      profile: new FormControl(''),
    });
  }

  /* Invidual form field check */
  public checkError = (form, controlName: string, errorName: string) => {
    return this[form].controls[controlName].hasError(errorName);
  }
  async handleUpload(event) {
    this.profileImage = await this.file.fileHandeleBase64(event);
    this.editOrganizationForm.controls.profile.patchValue(this.profileImage);
    this.editOrganizationForm.controls.profile.patchValue(this.profileImage);
    this.fieldChange(this.profileImage, 'file', 'profile');
  }
  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();

    }
  }
  reUpload(field) {
    document.getElementById(field).click();
  }

  cancelImage() {
    this.profileImage = '';
    this.editOrganizationForm.controls.profile.patchValue('');
  }


  settingFormLoad() {
    this.editSettingsForm = this.formBuilder.group({
      name: ['', Validators.required],
      userEmail: ['', [Validators.required, Validators.email]],
      designation: ['', [Validators.required]],
      contactNumber: ['', [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')]],
      call: [false],
      email: [false],
      push: [false],
      sms: [false],
      empSolution: [false],
      fleet: [false],


    });
  }
  get f() { return this.editSettingsForm.controls; }

  async getOrgList() {
    const obj = {
      orgID: this.orgID
    };
    this.api.listOrg(obj).then((res: any) => {
      if (res.status == 'success') {
        this.OrgData = res.data;
        this.setOrgDataToForm();
      }
      this.enableForm = true;
    }).catch((err) => {
      console.log(err);
    });

    //  seting list api
    // console.log(obj);

    await this.api.masterOrgFieldMapSettingList(obj).then((res: any) => {
      this.response = res['data'][0]['fieldMap'];
      if (res['data'][0]?.general != undefined) {
        // this.general = res['data'][0]['general'];
        // this.general.driverTokenExp = this.general.driverTokenExp;
        // this.general.driverTrackingInterval = this.general.driverTrackingInterval;

        // for (let key in res['data'][0]['general']) {
        //   if (key in this.general) {
        //     this.general[key] = res['data'][0]['general'][key];
        //   }
        // }

        for (let key in res['data'][0]['general']) {

  // ✅ HANDLE DATE CONVERSION HERE
  if (key === 'subscriptionExpiryDate' && res['data'][0]['general'][key]) {
    const d = new Date(res['data'][0]['general'][key]);

// Extract LOCAL date manually (NO ISO, NO UTC)
const year = d.getFullYear();
const month = String(d.getMonth() + 1).padStart(2, '0');
const day = String(d.getDate()).padStart(2, '0');

this.general[key] = `${year}-${month}-${day}`;
  } 
  else if (key in this.general) {
    this.general[key] = res['data'][0]['general'][key];
  }

}
        this.dropdownOptions = this.general.empAttendance;
        this.brakingDisable = this.general['harshAccBraking'] ? true : false;
      } else {
        this.general = this.general;
      }
      this.generalSettingsList.forEach(setting => {
        if (this.general.hasOwnProperty(setting.value)) {
          setting.checked = this.general[setting.value] === true;
        }
      });
    }).catch((err) => {
      console.log(err)
    });
    this.api.org_settingsList(obj).then(async (res: any) => {
      this.settingsList = res.data;

      let admins = res.data['userInfo'].filter(e => e.userType == 'admin');
      if (admins.length > 0 && admins[0]['fieldMap']) {
        this.userRestrictionData = JSON.parse(JSON.stringify(admins[0]['fieldMap']));

        // this.mergeObjects(this.userRestrictionData,this.response)
        if (this.userRestrictionData['Reports'].menu1['Night Drive Report'] == undefined) {
          this.userRestrictionData['Reports'].menu1['Night Drive Report'] = this.response['Reports'].menu1['Night Drive Report'];
        }
        if (this.userRestrictionData['Reports'].menu1['Tow Alert Report'] == undefined) {
          this.userRestrictionData['Reports'].menu1['Tow Alert Report'] = this.response['Reports'].menu1['Tow Alert Report'];
        }
        if (this.userRestrictionData['Reports'].menu1['Continuous  Driving Report'] == undefined) {
          this.userRestrictionData['Reports'].menu1['Continuous Driving Report'] = this.response['Reports'].menu1['Continuous Driving Report'];
        }
        if (this.userRestrictionData['Reports'].menu1['Mobile App Usage Report'] == undefined) {
          this.userRestrictionData['Reports'].menu1['Mobile App Usage Report'] = this.response['Reports'].menu1['Mobile App Usage Report'];
        }
        // if (this.userRestrictionData['Reports'].menu1['Driver App Usage Report'] == undefined) {
        //   this.userRestrictionData['Reports'].menu1['Driver App Usage Report'] = this.response['Reports'].menu1['Driver App Usage Report'];
        // }
        this.userRestrictionData['Reports'].menu1['MIS Report'] = this.response['Reports'].menu1['MIS Report'];
        if (this.userRestrictionData['Route / Rostering'].menu1['Roster'] == undefined) {
          this.userRestrictionData['Route / Rostering'].menu1['Roster'] = this.response['Route / Rostering'].menu1["Roster"]
        } else {
          this.userRestrictionData = JSON.parse(JSON.stringify(admins[0]['fieldMap']));
        }
      } else {
        this.userRestrictionData = this.response;
      }
      if (this.userRestrictionData['Reports'].menu1['Continuous Driving Report'] == undefined) {
        this.userRestrictionData['Reports'].menu1['Continuous Driving Report'] = this.response['Reports'].menu1['Continuous Driving Report'];
      }
      // if (this.userRestrictionData['Reports'].menu1['Driver App Usage Report'] == undefined) {
      //   this.userRestrictionData['Reports'].menu1['Driver App Usage Report'] = this.response['Reports'].menu1['Driver App Usage Report'];
      // }
      if (this.userRestrictionData['Reports'].menu1['Mobile App Usage Report'] == undefined) {
        this.userRestrictionData['Reports'].menu1['Mobile App Usage Report'] = this.response['Reports'].menu1['Mobile App Usage Report'];
      }
      if (this.userRestrictionData['Reports'].menu1['Harsh Acceleration Braking'] == undefined) {
        this.userRestrictionData['Reports'].menu1['Harsh Acceleration Braking'] = this.response['Reports'].menu1['Harsh Acceleration Braking'];
      }
      this.tableData = JSON.parse(JSON.stringify(this.userRestrictionData));
      this.headers = Object.keys(this.tableData);
      this.setDataToForm();
    }).catch((err) => {
      console.log(err);
    });
  }

  mergeObjects(mainObject, comparisonObject) {
    for (let key in comparisonObject) {
      // Check if key exists in mainObject
      if (!(key in mainObject)) {
        // If the key is missing, assign it from the comparisonObject
        mainObject[key] = comparisonObject[key];
      } else if (typeof comparisonObject[key] === 'object' && comparisonObject[key] !== null && !Array.isArray(comparisonObject[key])) {
        // If the key is an object, recursively merge
        this.mergeObjects(mainObject[key], comparisonObject[key]);
      }
    }
  }
  setOrgDataToForm() {
    this.enableForm = false;
    this.editOrganizationForm.patchValue({
      orgName: this.OrgData[0].orgName,
      orgEmail: this.OrgData[0].orgEmail,
      website: this.OrgData[0].website,
      country: this.OrgData[0].country,
      state: this.OrgData[0].state,
      city: this.OrgData[0].city,
      address: this.OrgData[0].address,
      pincode: this.OrgData[0].pincode,
      primaryContactName: this.OrgData[0].primaryContactName,
      primaryContactEmail: this.OrgData[0].primaryContactEmail,
      primaryContactNumber: this.OrgData[0].primaryContactNumber,
      primaryContactRole: this.OrgData[0].primaryContactRole,
      secondaryContactName: this.OrgData[0].secondaryContactName,
      secondaryContactEmail: this.OrgData[0].secondaryContactEmail,
      secondaryContactNumber: this.OrgData[0].secondaryContactNumber,
      secondaryContactRole: this.OrgData[0].secondaryContactRole,
      map: this.OrgData[0].map,
      profile: this.OrgData[0].profile,
    });
    this.profileImage = this.OrgData[0].profile;
    setTimeout(() => { this.enableForm = true; }, 200);
  }

  setDataToForm() {
    this.editSettingsForm.patchValue({
      name: this.settingsList.userInfo[0] && this.settingsList.userInfo[0].name ? this.settingsList.userInfo[0].name : '',
      userEmail: this.settingsList.userInfo[0] && this.settingsList.userInfo[0].userEmail ? this.settingsList.userInfo[0].userEmail : '',
      designation: this.settingsList.userInfo[0] && this.settingsList.userInfo[0].designation ? this.settingsList.userInfo[0].designation : '',
      contactNumber: this.settingsList.userInfo[0] && this.settingsList.userInfo[0].contactNumber ? this.settingsList.userInfo[0].contactNumber : '',
      call: this.settingsList.alert[0] && this.settingsList.alert[0].call ? this.settingsList.alert[0].call : false,
      email: this.settingsList.alert[0] && this.settingsList.alert[0].email ? this.settingsList.alert[0].email : false,
      push: this.settingsList.alert[0] && this.settingsList.alert[0].push ? this.settingsList.alert[0].push : false,
      sms: this.settingsList.alert[0] && this.settingsList.alert[0].sms ? this.settingsList.alert[0].sms : false,
      empSolution: this.settingsList.services[0] && this.settingsList.services[0].empSolution ? this.settingsList.services[0].empSolution : false,
      fleet: this.settingsList.services[0] && this.settingsList.services[0].fleet ? this.settingsList.services[0].fleet : false,
    });
    // console.log(this.editSettingsForm.value)
  }
  onSubmit() {
    console.log("callOnsubmit=======");
    this.submittedform = true;
    this.settingsFormSubmit = true;
    // stop here if form is invalid
    if (this.editSettingsForm.invalid) {
      return;
    } else {
      const obj = {
        userInfo: {
          name: this.editSettingsForm.value.name,
          userEmail: this.editSettingsForm.value.userEmail,
          designation: this.editSettingsForm.value.designation,
          contactNumber: this.editSettingsForm.value.contactNumber,
          userID: this.settingsList['userInfo'] && this.settingsList['userInfo'][0] && this.settingsList['userInfo'][0]['userID'] ? this.settingsList['userInfo'][0]['userID'] : '',
        },
        service: {
          empSolution: this.editSettingsForm.value.empSolution,
          fleet: this.editSettingsForm.value.fleet,
        },
        alert: {
          email: this.editSettingsForm.value.email,
          call: this.editSettingsForm.value.call,
          push: this.editSettingsForm.value.push,
          sms: this.editSettingsForm.value.sms,
        },
        orgID: this.orgID
      };
      this.api.org_settings_update(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction('success', res.status, res.message, 2000);
          this.router.navigate(['/master/organization/view-org']);
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 2000);
        }
      }).catch((err) => {
        console.log(err);
      });
      // display form values on success
      // console.log(this.editSettingsForm.value);
    }
  }

  fieldChange(e: any, type, field) {
    // console.log(e,type,field);
    if (type == 'text' || type == 'textarea') {
      let value = e.target.value;
      if ((field == 'orgEmail' || field == 'primaryContactEmail' || field == 'secondaryContactEmail') && value != '')
        value = value.toLowerCase();
      this.updateField(field, value);
    }
    if (type == 'date' || type == 'dropdown') {
      this.updateField(field, e.value);
    }
    if (type == 'file') {
      this.updateField(field, e);
    }
  }
  updateField(field, value) {
    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value, };
      this.updateValues = [
        ...filterUpdate,
        obj,
      ]
    }
    else {
      let obj = { field: field, value: value, };
      this.updateValues.push(obj);
    }
    // console.log(this.updateValues);
  }

  submitted() {
    this.formSubmitted = true;
    // console.log(this.editOrganizationForm.value);
    if (this.editOrganizationForm.valid) {
      if (this.editOrganizationForm.valid && this.updateValues && this.updateValues.length > 0) {

        const obj = {
          orgID: this.orgID,
        };

        this.updateValues.filter((e) => {
          obj[e.field] = e.value;
        });
        // console.log(obj);
        this.api.updateOrg(obj).then((res: any) => {
          if (res.status == 'success') {
            this.swal.swalFunction(res.status, res.status, res.message, 2000);
            this.router.navigate(['/master/organization/view-org']);
          }
          if (res.status == 'failure') {
            this.swal.swalFunction('error', res.status, res.message, 2000);
          }
        }).catch((err) => {
          console.log(err);
        });
      }
    } else {
      console.log('Form field invalid');
    }
  }
  findActiveMenu(menu) {
    this.activeMenu = menu;
  }
  //for field map
  showNestedData(id) {
    let btn = document.getElementById(id);
    if (btn.classList.contains('fa-chevron-down')) {
      btn.classList.replace('fa-chevron-down', 'fa-chevron-up');
    } else {
      btn.classList.replace('fa-chevron-up', 'fa-chevron-down');
    }
  }
  selectModule(event, value, moduleIndex) {
    this.tableData[value].checked = event;
    this.tableData[value].indeterminate = false;
    // this.tableData[value].indeterminate=!event;
    if (this.tableData[value].menu1) {
      let sub1 = this.tableData[value].menu1;
      let subModules1 = Object.keys(sub1);
      for (let i = 0; i < subModules1.length; i++) {
        sub1[subModules1[i]].checked = event;
        sub1[subModules1[i]].indeterminate = false;

        if (sub1[subModules1[i]].menu2) {
          let sub2 = sub1[subModules1[i]].menu2;
          let subModules2 = Object.keys(sub2);
          for (let j = 0; j < subModules2.length; j++) {
            sub2[subModules2[j]].checked = event;
            sub2[subModules2[j]].indeterminate = false;

            if (sub2[subModules2[j]].menu3) {
              let sub3 = sub2[subModules2[j]].menu3;
              let subModules3 = Object.keys(sub3);
              for (let k = 0; k < subModules3.length; k++) {
                sub3[subModules3[k]].checked = event;
                sub3[subModules3[k]].indeterminate = false;
              }
            }
          }
        }
      }
    }
  }
  selectSubmodule1(event, selectedModule, selectedSubmodule1, moduleIndex, subModule1Index) {
    this.tableData[selectedModule].menu1[selectedSubmodule1].checked = event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = false;
    // this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!event;
    if (this.tableData[selectedModule].menu1[selectedSubmodule1].menu2) {
      let sub2 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
      let subModules2 = Object.keys(sub2);
      for (let i = 0; i < subModules2.length; i++) {
        sub2[subModules2[i]].checked = event;
        sub2[subModules2[i]].indeterminate = false;

        if (sub2[subModules2[i]].menu3) {
          let sub3 = sub2[subModules2[i]].menu3;
          let subModules3 = Object.keys(sub3);
          for (let j = 0; j < subModules3.length; j++) {
            sub3[subModules3[j]].checked = event;
            sub3[subModules3[j]].indeterminate = false;
          }
        }
      }
    }
    this.checkModuleIndeterminateOrChecked(event, selectedModule);
  }
  checkModuleIndeterminateOrChecked(event, selectedModule) {
    let sub1 = this.tableData[selectedModule].menu1;
    let subModules1 = Object.keys(sub1);
    let isValid = true;
    for (let i = 0; i < subModules1.length; i++) {
      if ((sub1[subModules1[i]].checked == false || sub1[subModules1[i]].checked == undefined || sub1[subModules1[i]].indeterminate == false)) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.tableData[selectedModule].checked = isValid;
      this.tableData[selectedModule].indeterminate = !isValid;
    } else {
      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < subModules1.length; i++) {
        if (sub1[subModules1[i]].checked) {
          checkArr.push('checked');
        } else if (sub1[subModules1[i]].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        this.tableData[selectedModule].indeterminate = isValid;
        this.tableData[selectedModule].checked = isValid;
      } else if (checkArr.length == subModules1.length) {
        this.tableData[selectedModule].checked = !isValid;
        this.tableData[selectedModule].indeterminate = isValid;
      } else if (indeterArr.length == subModules1.length) {
        this.tableData[selectedModule].indeterminate = !isValid;
        this.tableData[selectedModule].checked = isValid;
      } else {
        this.tableData[selectedModule].indeterminate = !isValid;
        this.tableData[selectedModule].checked = isValid;
      }
    }
  }
  selectSubmodule2(event, selectedModule, selectedSubmodule1, selectedSubmodule2, moduleIndex, subModule1Index, subModule2Index) {
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = false;
    if (this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3) {
      let sub3 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
      let subModules3 = Object.keys(sub3);
      for (let i = 0; i < subModules3.length; i++) {
        sub3[subModules3[i]].checked = event;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event, selectedModule, selectedSubmodule1);
  }
  checkSubmodule1IndeterminateOrChecked(event, selectedModule, selectedSubmodule1) {
    let sub2 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
    let subModules2 = Object.keys(sub2);
    let isValid = true;
    for (let i = 0; i < subModules2.length; i++) {
      if ((sub2[subModules2[i]].checked == false || sub2[subModules2[i]].checked == undefined || sub2[subModules2[i]].indeterminate == false)) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = !isValid;
    } else {
      let checkArr = [];
      let indeterArr = [];
      for (let i = 0; i < subModules2.length; i++) {
        if (sub2[subModules2[i]].checked) {
          checkArr.push('checked');
        } else if (sub2[subModules2[i]].indeterminate) {
          indeterArr.push('indeterminate');
        }
      }
      if (checkArr.length <= 0 && indeterArr.length <= 0) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      } else if (checkArr.length == subModules2.length) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = isValid;
      } else if (indeterArr.length == subModules2.length) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      } else {
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked = isValid;
      }
    }
    this.checkModuleIndeterminateOrChecked(event, selectedModule);
  }
  selectSubmodule3(event, selectedModule, selectedSubmodule1, selectedSubmodule2, selectedSubmodule3, moduleIndex, subModule1Index, subModule2Index, subModule3Index) {
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].checked = event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].indeterminate = false;
    this.checkSubmodule2IndeterminateOrChecked(event, selectedModule, selectedSubmodule1, selectedSubmodule2, selectedSubmodule3)
  }

  checkSubmodule2IndeterminateOrChecked(event, selectedModule, selectedSubmodule1, selectedSubmodule2, selectedSubmodule3) {
    let sub3 = this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
    let subModules3 = Object.keys(sub3);
    let isValid = true;
    for (let i = 0; i < subModules3.length; i++) {
      if ((!sub3[subModules3[i]].checked)) {
        isValid = false;
        break;
      } else {
        isValid = true;
      }
    }
    if (isValid) {
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = !isValid;
    } else {
      let arr = [];
      for (let i = 0; i < subModules3.length; i++) {
        arr.push(sub3[subModules3[i]].checked);
      }
      let value = arr.filter(e => e == true);
      if (value.length <= 0) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = isValid;
      } else if (value.length == subModules3.length) {
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = !isValid;
      } else {
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate = !isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked = isValid;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event, selectedModule, selectedSubmodule1);
  }
  submitFieldMap() {
    let obj = {
      orgID: this.orgID,
      fieldMap: this.tableData
    };
    let keys = Object.keys(this.tableData);
    let isValid = false;
    for (let i = 0; i < keys.length; i++) {
      if (this.tableData[keys[i]].checked || this.tableData[keys[i]].indeterminate) {
        isValid = true;
        break;
      } else {
        isValid = false;
      }
    }
    if (isValid) {
      this.api.org_settings_update(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
        }
        if (res.status == 'failure') {
          console.log('settings error');
          const msg = [];
          const rstmsg = res.message;
          rstmsg.orgID.forEach(function (eror) {
            console.log(eror);
            this.msg.push(eror);
          });

          this.swal.swalFunction('error', res.status, msg, 2000);
        }

      })
        .catch((err) => {
          console.log(err);
        });
    } else {
      this.swal.swalFunction('error', 'Failure', 'You must select atleast one module!', 2000);
    }
  }
  goBackToList() {
    this.router.navigateByUrl('master/organization/view-org');
  }

  selectSetting(value, setting, field) {

    const updateGeneralAndFiles = (key, value) => {
      this.general[key] = value;
      this.changed = true;
    };

    if (field === 'checkbox') {
      const settingsToUpdate = [
        'multiTripStart',
        'empAppPolyline',
        'clicktocall',
        'breakDown',
        'event',
        'selfAttendanceForEmp',
        'harshAccBraking',
        'documentExpiryAlert'

      ];

      if (settingsToUpdate.includes(setting)) {
        updateGeneralAndFiles(setting, value);
      } else if (setting === 'harshAccBraking') {
        updateGeneralAndFiles(setting, value);
        this.brakingDisable = value ? true : false;
      }

      return; // Early return to avoid unnecessary checks
    }

    if (field === 'select' && setting === 'empAttendance') {
      updateGeneralAndFiles('empAttendance', value);
      return;
    }

    if (field === 'input' && setting === 'driverTokenExp') {
      const parsedValue = parseInt(value);
      if (parsedValue > 10) {
        this.disableTrue = true;
        this.changed = false;
      } else {
        this.disableTrue = false;
        updateGeneralAndFiles('driverTokenExp', parsedValue);
      }
      return;
    }

    if (field === 'input' && setting === 'timeIntrevel') {
      const timeInterval = parseInt(value);
      if (timeInterval > 300) {
        this.disableTrue2 = true;
        this.changed = false;
        this.errorContent = 'The maximum allowed should be 300 seconds!';
      } else if (timeInterval === 0) {
        this.disableTrue2 = true;
        this.changed = false;
        this.errorContent = 'The minimum allowed should be 10 seconds!';
      } else {
        this.disableTrue2 = false;
        updateGeneralAndFiles('driverTrackingInterval', timeInterval);
      }
      return;
    }

    if (field === 'input' && setting === 'harshAccThreshold') {
      const harshAccValue = parseFloat(value);
      if (harshAccValue < 0.08) {
        this.disableTrue3 = true;
        this.changed = false;
        this.errorContentHarshAcc = 'The minimum allowed value should be 0.08 m/s²!';
      } else {
        this.disableTrue3 = false;
        updateGeneralAndFiles('harshAccThreshold', harshAccValue);
      }
      return;
    }

    if (field === 'input' && setting === 'harshBrakingThreshold') {
      const harshBrakingValue = parseFloat(value);
      if (harshBrakingValue < 0.08) {
        this.disableTrue4 = true;
        this.changed = false;
        this.errorContentHarshBreak = 'The minimum allowed value should be 0.08 m/s²!';
      } else {
        this.disableTrue4 = false;
        updateGeneralAndFiles('harshBrakingThreshold', harshBrakingValue);
      }
      return;
    }

    if (field === 'input' && setting === 'subscriptionExpiryDate') {
      updateGeneralAndFiles('subscriptionExpiryDate', value);
      return;
    }
  }

  // submitgeneralSettings() {
  //   console.log("Submit General settings",this.changed );

  //   if (this.changed == true) {
  //     // this.general['driverTokenExp'] = +this.general['driverTokenExp'];
  //     let obj = {
  //       orgID: this.orgID,
  //       general: this.general
  //     }
  //     if (this.general['harshAccBraking'] == false) delete obj['general']['harshAccThreshold'], delete obj['general']['harshBrakingThreshold'];

  //     this.api.org_settings_update(obj).then((res: any) => {
  //       if (res.status == 'success') {
  //         this.swal.swalFunction(res.status, res.status, res.message, 2000);
  //         this.router.navigate(['/master/organization/view-org']);
  //       }
  //       if (res.status == 'failure') {
  //         this.swal.swalFunction('error', res.status, res.message, 2000);
  //       }
  //     }).catch((err) => {
  //       console.log(err);
  //     });
  //   }

  // }

  submitgeneralSettings() {
  console.log("Submit General settings", this.changed);

  if (this.changed == true) {

    // ✅ CONVERT DATE TO TIMESTAMP
    if (this.general.subscriptionExpiryDate) {
      const d = new Date(this.general.subscriptionExpiryDate);
      this.general.subscriptionExpiryDate = new Date(d.getFullYear(), d.getMonth(),d.getDate()).getTime();
    }

    let obj = {
      orgID: this.orgID,
      general: this.general
    };

    // existing logic (no change)
    if (this.general['harshAccBraking'] == false) {
      delete obj['general']['harshAccThreshold'];
      delete obj['general']['harshBrakingThreshold'];
    }

    this.api.org_settings_update(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.router.navigate(['/master/organization/view-org']);
      }
      if (res.status == 'failure') {
        this.swal.swalFunction('error', res.status, res.message, 2000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
}
}
